module.exports = __webpack_public_path__ + "static/img/icon3.97e71b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/dataCenter/icon3.png
// module id = YbqD
// module chunks = 1